module.exports = "/images/Building---Hero.jpg";